(ns client-portal.client.user-management.organizations.data
  (:require [client-portal.client.user-management.data :as um.d]
            [clojure.string :as s]
            [shared.core.reactive :as re]
            [shared.core.util :as util]))

(def form-path (conj um.d/root-path :organization-form))
(def save-path (conj um.d/root-path :organization-save))

(def hex-color-pattern #"(?i)#(?:[0-9a-f]{6}|[0-9a-f]{3})")

(re/reg-event-db
  :user-management/edit-organization re/middleware
  (fn [db [organization]]
    (re/dispatch [:dialog/show [:user-management/organization-dialog]])
    (assoc-in db form-path (merge {:concept-ids []}
                                  (select-keys organization [:tenant-organization-id :external-id :label :concept-ids
                                                             :org-logo :primary-color :secondary-color])))))

(re/reg-sub :user-management/organization-form- #(get-in % form-path))

(defn problems [{:keys [label primary-color secondary-color]}]
  (cond-> {}
          (s/blank? label)
          (assoc :label "Enter a name")

          (some #(and (not (s/blank? %)) (not (re-matches hex-color-pattern (s/trim %)))) [primary-color secondary-color])
          (assoc :colors "Use hex values, like #1A2B3C")

          (not= (s/blank? primary-color) (s/blank? secondary-color))
          (assoc :colors "Set both colors, or leave both blank")))

(re/auth0-http-request
  :user-management/save-organization
  save-path
  (fn [db _]
    (let [{:keys [tenant-organization-id label concept-ids org-logo primary-color secondary-color] :as form}
          (get-in db form-path)]
      (when (empty? (problems form))
        {:method :post
         :url (um.d/with-tenant "/api/user-management/organizations" (um.d/current-tenant db))
         :json-params (util/->camelCaseKeywords
                        (cond-> {:label (s/trim label)
                                 :concept-ids (vec concept-ids)
                                 :org-logo (some-> org-logo (s/trim))
                                 :primary-color (some-> primary-color (s/trim))
                                 :secondary-color (some-> secondary-color (s/trim))}
                                tenant-organization-id (assoc :tenant-organization-id tenant-organization-id)))})))
  :on-success (fn [db [{:keys [body]}] _]
                (re/dispatch [:dialog/hide])
                (re/dispatch [:toasts/add-info {:msg (if (get-in db (conj form-path :tenant-organization-id))
                                                       "Organization saved"
                                                       (str "Created " (:label body)))
                                                :duration 3000}])
                (re/dispatch [:user-management/load-organizations (um.d/current-tenant db) :reload])
                db)
  :on-fail (fn [db {:keys [body]} _]
             (re/dispatch [:toasts/add-error {:msg (or (:message body) "Couldn't save the organization. Try again.")
                                              :duration 6000}])
             db))

(re/reg-sub :user-management/saving-organization?- #(get-in % (conj save-path :request-active?)))
